import { useEffect } from 'react';

import { requestStorefrontInquiryStats } from '~/actions/vendors/vendorInquiriesActions';
import { useAppDispatch, useAppSelector } from '~/reducers';
import { InquiryStatsState } from '~/reducers/vendorInquiriesReducer';
import { getCurrentStorefrontUuid } from '~/selectors/vendorAccountSelectors';

// This is guard on fetching the stats more than once when this hook is used many times on a page
let statsRequestedForStorefrontUuid: string | null = null;

/**
 * Fetches and selects the current storefront's inquiry statistics from the backend
 */
export const useInquiryStats = (): InquiryStatsState => {
  const dispatch = useAppDispatch();
  const storefrontUuid = useAppSelector(getCurrentStorefrontUuid);
  const storefrontInquiryStats = useAppSelector((state) => state.vendorInquiries.inquiryStats);

  useEffect(() => {
    if (storefrontUuid && statsRequestedForStorefrontUuid !== storefrontUuid) {
      statsRequestedForStorefrontUuid = storefrontUuid;
      dispatch(requestStorefrontInquiryStats(storefrontUuid)).catch(() => null);
    }
  }, [dispatch, storefrontUuid]);

  return storefrontInquiryStats;
};
